import { ClassTransformer } from './ClassTransformer.js';
export { ClassTransformer } from './ClassTransformer.js';

var classTransformer = new ClassTransformer();
function classToPlain(object, options) {
  return classTransformer.instanceToPlain(object, options);
}
function instanceToPlain(object, options) {
  return classTransformer.instanceToPlain(object, options);
}
function plainToClass(cls, plain, options) {
  return classTransformer.plainToInstance(cls, plain, options);
}

export { classToPlain, instanceToPlain, plainToClass };
//# sourceMappingURL=index.js.map
